export const SLOT_INIT_SPACE_TYPE = 'SLOT_INIT_SPACE_TYPE';
export const SLOT_PARK_VEHICLE_TYPE = 'SLOT_PARK_VEHICLE_TYPE';
export const SLOT_UNPARK_VEHICLE_TYPE = 'SLOT_UNPARK_VEHICLE_TYPE';
export const SLOT_MAP_TYPE = 'SLOT_MAP_TYPE';
